import './header.component.scss';

const header = document.querySelector('.header')
if (header) {
  const resizeVariables = () => {
    const doc = document.documentElement
    const appHeight = () => {
      doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    }
    const headerHeight = () => {
      doc.style.setProperty('--header-height', `${header.clientHeight}px`)      
    }
    const centerDifference = () => {
      const calc = () => {
        const leftWidth = document.querySelector('.header__location').offsetWidth + document.querySelector('.header nav.nav li:nth-child(1)').offsetWidth + document.querySelector('.header nav.nav li:nth-child(2)').offsetWidth
        const rightWidth = document.querySelector('.header__btn-area').offsetWidth + document.querySelector('.header nav.nav li:nth-child(4)').offsetWidth + document.querySelector('.header nav.nav li:nth-child(5)').offsetWidth

        if (leftWidth > rightWidth) {
          return +(leftWidth) - +(rightWidth)
        } else {
          return +(rightWidth) - +(leftWidth)
        }
      }
      
      header.style.setProperty('--center-difference', `${calc()}px`)
    }
    appHeight()
    headerHeight()

    if (window.innerWidth > 1280) {
      centerDifference()
    }
  }
  window.addEventListener('DOMContentLoaded', resizeVariables)
  window.addEventListener('resize', resizeVariables)
}